module.exports = __webpack_public_path__ + "img/w3_outlet_dark.348f1a69.png";